import "./monthBars.css";

/**
 * Twelve months as bars, the overview's visits since build round 4 and every statistics result since
 * build round 37 (2026-10-11), which moved it here so the two pages share one component and one style.
 *
 * An empty slot is a month nothing was measured in (or, on /statistics, a figure held for checking): a
 * dashed baseline rather than a bar of zero. The month in progress is lighter, because it is not a
 * whole month yet. Each bar is spoken in full, because the bars themselves are decoration.
 */
export interface MonthBarItem {
  month: string;
  /** Three letters under the bar. */
  short: string;
  /** What a screen reader hears and a pointer's title shows, for example "september 2026: 12 besök". */
  spoken: string;
  /** Null for a month not measured, which draws the dashed baseline. */
  value: number | null;
  current?: boolean;
}

export function MonthBars({
  bars,
  label,
  testId,
  barTestId
}: {
  bars: MonthBarItem[];
  label: string;
  testId?: string;
  barTestId?: string;
}) {
  const peak = Math.max(0, ...bars.map((bar) => bar.value ?? 0));
  return (
    <ol className="k-bars" aria-label={label} data-testid={testId}>
      {bars.map((bar) => {
        const height = bar.value && peak > 0 ? Math.max(4, Math.round((bar.value / peak) * 100)) : 0;
        return (
          <li
            key={bar.month}
            className={`${bar.value === null ? "is-empty" : ""}${bar.current ? " is-current" : ""}`.trim() || undefined}
            title={bar.spoken}
            data-testid={barTestId}
          >
            <span className="k-bar" aria-hidden="true">
              <i style={{ height: `${height}%` }} />
            </span>
            <span className="k-bar-label" aria-hidden="true">
              {bar.short}
            </span>
            <span className="visually-hidden">{bar.spoken}</span>
          </li>
        );
      })}
    </ol>
  );
}
